/*
**    权限管理相关路由
*/
export default [{
    path: 'user',
    name: 'user',
    meta: {
      title: '子账号管理'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/power/user/index.vue')
  }, {
    path: 'editUser',
    name: 'editUser',
    meta: {
      title: '编辑或查看用户'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/power/user/editUser.vue')
  },
  {
    path: 'role',
    name: 'role',
    meta: {
      title: '功能角色管理'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/power/role/index.vue')
  }, {
    path: 'editRole',
    name: 'editRole',
    meta: {
      title: '编辑或查看功能角色'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/power/role/editRole.vue')
  },
]